<script>
  import { fade } from "svelte/transition";
  import Swiper from "./Swiper.svelte";
  import { navigate } from "svelte-routing";
  let accepted = false;
  let startAudio = null;
  function accept(evt) {
    evt.preventDefault();
    // hacky but works
    document.body.appendChild(startAudio);
      startAudio.play();
    setTimeout(() => {
      navigate("/gallery");
      window.scrollTo(0, 0);
    }, 100);

  }

  const firstSlide = `fuckboy
/ˈfəkˌboi/
noun VULGAR SLANG • DEROGATORY
a weak or contemptible man.
a man who has many casual sexual partners.
a man doesn’t respect women, but relies on them heavily financially, sexually or emotionally.
an emotionally unavailable man who seduces women but who will not make commitments.
a self-absorbed, immature man who fucks with others’ emotions.
`;
</script>

<audio
  controls="false"
  class="hidden"
  src="/audio/start.wav"
  bind:this={startAudio}
>
  <track kind="captions" />
</audio>
<div class="pb-30">
  {#if accepted}
    <div transition:fade>
      <Swiper />
    </div>
  {:else}

    <h3 class="text-3xl font-pixel mt-6">WARNING</h3>
    <div class="whitespace-pre-line font-body p-4">
      before taking a fboy home, please agree to the terms
    </div>
    <div class="whitespace-pre-line font-body p-4">
      {firstSlide}
    </div>
    <div class="py-10">
    <a
      href="/gallery"
      on:click={accept}
      class="pt-4 display-block text-black bg-pinkBottom text-2xl flex-shrink font-pixel p-4 hover:shadow-xl color-pinkAccent hover:text-normal shadow-lg rounded-xl"
      >I ACCEPT <span class="hidden lg:inline">THESE RISKS</span></a>
      </div>
  {/if}
</div>
